export function formatDateTime(value) {
  if (!value) return ''
  const text = String(value).trim()
  if (!text) return ''

  const normalized = text
    .replace('T', ' ')
    .replace('.000Z', '')
    .replace('Z', '')

  if (normalized.length >= 16) {
    return normalized.slice(0, 16)
  }
  return normalized
}
